<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="clueDetails">
            <van-loading
                class="pageLogin"
                v-if="loading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="线索详情"
                left-text="线索管理"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <div class="clueInfo">
                    <van-cell-group>
                        <van-cell
                            title="线索编号"
                            :value="clueDetails.clue_number"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                        ></van-cell>
                        <van-cell
                            title="客户名称"
                            :value="clueDetails.client_name"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                        ></van-cell>
                        <van-cell
                            title="工程名称"
                            :value="clueDetails.engineering_name"
                            :icon="require('@/assets/images/icons/icon_2.png')"
                        ></van-cell>
                        <van-cell
                            title="工程位置"
                            :value="clueDetails.engineering_location"
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                        ></van-cell>
                    </van-cell-group>
                </div>
                <van-steps direction="vertical">
                    <template v-for="(item, index) in clueDetails.tracks">
                        <van-step :key="index">
                            <h3>{{ item.record_time | format }}</h3>
                            <div class="listBox" @click="openClueRecord(item)">
                                <div class="userInfo">
                                    <div class="van_left headPortrait">
                                        <img src="@/assets/images/addressBook/b_head_portrait_man@2x.png" alt="">
                                    </div>
                                    <p class="van_left info">
                                        <span class="name">{{ item.record_user_name }}</span>
                                        <!-- <span class="post">{{ item.record_user_id }}</span> -->
                                    </p>
                                </div>
                                <p class="state">
                                    {{ item.project_phase_name }}
                                </p>
                                <p class="intention">
                                    {{ item.track_record }}
                                </p>
                            </div>
                        </van-step>
                    </template>
                </van-steps>
            </section>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 线索详情
    name: 'clue-details',
    components: {},
    props: {},
    data() {
        return {
            // 线索数据
            clueData: '',
            // 页面加载状态
            loading: false,
            // 线索主键
            ciid: '',
            // 线索详情数据
            clueDetails: {},
        };
    },
    computed: {},
    watch: {},
    created() {
        this.ciid = this.$route.query.ciid;
        // 拉取线索详情数据
        this.gitClueDetailsData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/clueManagement' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/clueManagement' });
        },
        // 点环节打开线索记录页
        openClueRecord(data) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/clueRecord',
                query: {
                    data: this.clueDetails,
                    type: '/clueDetails',
                    record: data,
                },
            });
        },
        // 拉取线索详情数据
        gitClueDetailsData() {
            this.$axios
                .get('/interfaceApi/sale/clue_manager/get_clue/' + this.ciid)
                .then(res => {
                    this.clueDetails = res;
                }).catch(error => {
                    this.loading = false;
                    this.$dialog({ message: error });
                });
        },
    },
};

// 过滤时间不显示时分秒
import Vue from 'vue';
Vue.filter('format', function (value) {
    return value.slice(0, 10);
});

</script>
<style lang="stylus">
.clueDetails
    height 100%
    background #F0F0F0
    section
        height calc(100% - 45rpx)
        overflow-y scroll
        -webkit-overflow-scrolling: touch;
        .clueInfo
            background #fff
            .van-cell
                &:after
                    border-color #F0F0F0
            .van-cell__left-icon
                line-height 24rpx
                .van-icon__image
                    display: inline-block
                    vertical-align: text-bottom;
            .van-cell__title
                width 100rpx
                font-size 15rpx
                line-height 24rpx
                color #061F3E
            .van-collapse-item__content
                padding 0
            .van-field__control,
            .van-cell__value
                color #979EA7
                &::placeholder
                    color #D7D7D7 !important
        .van-steps
            background none
            .van-step--vertical
                &:first-child
                    &::before
                        background none
            .van-step__line
                background none
                border-left 1px  dashed #D7D7D7
            .van-step
                &:last-child
                    .van-step__line
                        border none
                h3
                    font-size 12rpx
                    color #979EA7
                .listBox
                    margin-top 15rpx
                    // height 100rpx
                    background #fff
                    border-radius 4rpx
                    padding 14rpx
                    position relative
                    .userInfo
                        height 42rpx
                        .headPortrait
                            width 42rpx
                            height 42rpx
                            border-radius 50%
                            margin-right 10rpx
                            img
                                width 100%
                                heihgt 100%
                        p
                            width calc(100% - 55rpx)
                            span
                                display block
                            .name
                                font-size 16rpx
                                line-height 42rpx
                                color #333333
                                margin-bottom 8rpx
                            .post
                                color #979EA7
                                overflow hidden
                                white-space nowrap
                                text-overflow ellipsis
                    .state
                        position absolute
                        right 14rpx
                        top 14rpx
                        color #00A84B
                        font-size 14rpx
                    .intention
                        font-size 14rpx
                        color #666666
                        margin-top 14rpx
                        text-align left
</style>